// extracted by mini-css-extract-plugin
module.exports = {"main":"ApplyButton_main__LXX_w","disabled":"ApplyButton_disabled__zF6sq"};